import TicketInboxProvider from './TicketInboxContext';
import TicketInbox from './TicketInbox';


let Index = () => {
    return (
        <TicketInboxProvider>
            <TicketInbox />
        </TicketInboxProvider>
    )
}

export default Index;